<template>
  <div class="empty_component">
    <img :width="imgWidth" src="@/assets/imgs/mobile/empty.png" alt="" />
    <div class="empty_text">没有找到数据</div>
  </div>
</template>
<script>
export default {
  props: {
    imgWidth: {
      type: String,
      default: '80%',
    },
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="scss">
.empty_component {
  width: 100%;
  text-align: center;
  .empty_text {
    font-size: 13px;
    color: #999;
    margin: 20px 0;
  }
}
</style>
